module.exports = __webpack_public_path__ + "img/tw.15e52c31.svg";